import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { includes } from 'lodash'
import config from '../../config'
import container from '../../helpers/container'
import {
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './Companies.css'


@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple: true})
export default class Companies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props) {
    super(props)
    this.state = {
      title: 'Companies',
      url: config.domain + config.routes.companies
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  render() {
    const companyList = this.props.result && this.props.result.length>0 ?
      this.props.result :
      null

    const ppIcon = require( '../../../static/images/icn-pp.svg' )
    const bordersIcon = require( '../../../static/images/icn-borders.svg' )
    const iconLabel = (title, icn=null) => {
      return (
        <div styleName='stat'>
          <div styleName='stat-count-wrapper'>
            <img
              src={icn}
              alt={title}
              styleName='stat-count'
            />
          </div>
          <div styleName='stat-label'>
            {title}
          </div>
        </div>
      )
    }

    const riskLabel = (title, styl) => {
      return (
        <div styleName='stat'>
          <div styleName='stat-count-wrapper'>
            <div styleName={'stat-count-'+styl}>
              <LinkIcon faclass='fa-exclamation-triangle fa-2x' nospace/>
            </div>
          </div>
          <div styleName={'stat-label-'+styl}>
            {title}
          </div>
        </div>
      )
    }
    //
    return (
      <div>
        {container.helmet(this.state.title, '', this.state.url)}
        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='title'>
                Companies
              </div>
              <div styleName='small-title'>
                The prison and border industries
              </div>
              <div styleName='h3'>
                <p>
                  On <strong>Prison Free Funds</strong>, we focus on two
                  aspects of the prison industrial complex: companies
                  involved in the prison industry (such as private
                  for-profit prison operators and prison services
                  providers), and companies involved in the
                  militarization of borders and the policing of immigration.
                </p>
                <ScreenedCompanies companyList={companyList}/>
              </div>
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <GetStartedInput />
        </div>
      </div>
    )
  }
}
